/* eslint-disable */

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDD3lzzdkg1eWP-zYWg2dMsh_HhPZ319nQ",
  authDomain: "ballkinder-app.firebaseapp.com",
  projectId: "ballkinder-app",
  storageBucket: "ballkinder-app.firebasestorage.app",
  messagingSenderId: "686957735232",
  appId: "1:686957735232:web:894a797b5d4fd4cb31dea5",
  measurementId: "G-V193BJSBF2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LeKT_8qAAAAAJh95-RzHrOnZsOPaixpnkaEFU9S'),

  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true
});
const analytics = getAnalytics(app);    
const db = getFirestore(app);
export const auth = getAuth(app);


export { db };
